import { PopUpCorner } from './PopUpCorner';

export type { TypePopUpCornerProps } from './types';
export default PopUpCorner;
